import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { StGroup } from './group.styled';
import { props } from './group.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkGroup',
  props: props,
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StGroup), _mergeProps({ as: _ctx.as }, _ctx.$props), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["as"]))
}
}

})